// THIS FILE IS AUTO-GENERATED BY PREBUILD SCRIPT - DO NOT EDIT

import cbFlume from './CombinedSewer/cbFlume.yaml';
import cbLateralPipe from './CombinedSewer/cbLateralPipe.yaml';
import cbManhole from './CombinedSewer/cbManhole.yaml';
import cbOrifice from './CombinedSewer/cbOrifice.yaml';
import cbOutfall from './CombinedSewer/cbOutfall.yaml';
import cbOutlet from './CombinedSewer/cbOutlet.yaml';
import cbPipe from './CombinedSewer/cbPipe.yaml';
import cbPump from './CombinedSewer/cbPump.yaml';
import cbPumpStation from './CombinedSewer/cbPumpStation.yaml';
import cbRoddingEye from './CombinedSewer/cbRoddingEye.yaml';
import cbScreen from './CombinedSewer/cbScreen.yaml';
import cbSiphon from './CombinedSewer/cbSiphon.yaml';
import cbSluice from './CombinedSewer/cbSluice.yaml';
import cbStorage from './CombinedSewer/cbStorage.yaml';
import cbValve from './CombinedSewer/cbValve.yaml';
import cbVortex from './CombinedSewer/cbVortex.yaml';
import cbWeir from './CombinedSewer/cbWeir.yaml';

import egACMitigationWire from './ESRIGas/egACMitigationWire.yaml';
import egAnode from './ESRIGas/egAnode.yaml';
import egBondingLine from './ESRIGas/egBondingLine.yaml';
import egCPCable from './ESRIGas/egCPCable.yaml';
import egCompressor from './ESRIGas/egCompressor.yaml';
import egControllableTee from './ESRIGas/egControllableTee.yaml';
import egControllableValve from './ESRIGas/egControllableValve.yaml';
import egCustomerPipe from './ESRIGas/egCustomerPipe.yaml';
import egDecoupler from './ESRIGas/egDecoupler.yaml';
import egDistributionPipe from './ESRIGas/egDistributionPipe.yaml';
import egExcessFlowValve from './ESRIGas/egExcessFlowValve.yaml';
import egFlowValve from './ESRIGas/egFlowValve.yaml';
import egGatheringPipe from './ESRIGas/egGatheringPipe.yaml';
import egGroundingPoint from './ESRIGas/egGroundingPoint.yaml';
import egLamp from './ESRIGas/egLamp.yaml';
import egLineStopper from './ESRIGas/egLineStopper.yaml';
import egLinearAnode from './ESRIGas/egLinearAnode.yaml';
import egMeter from './ESRIGas/egMeter.yaml';
import egPressureMonitoringDevice from './ESRIGas/egPressureMonitoringDevice.yaml';
import egPressureSensorPipe from './ESRIGas/egPressureSensorPipe.yaml';
import egPump from './ESRIGas/egPump.yaml';
import egRectifier from './ESRIGas/egRectifier.yaml';
import egRegulator from './ESRIGas/egRegulator.yaml';
import egReliefValve from './ESRIGas/egReliefValve.yaml';
import egRiserPipe from './ESRIGas/egRiserPipe.yaml';
import egScrubber from './ESRIGas/egScrubber.yaml';
import egServicePipe from './ESRIGas/egServicePipe.yaml';
import egServiceStation from './ESRIGas/egServiceStation.yaml';
import egStationPipe from './ESRIGas/egStationPipe.yaml';
import egStoragePipe from './ESRIGas/egStoragePipe.yaml';
import egStrainer from './ESRIGas/egStrainer.yaml';
import egTestLeadWire from './ESRIGas/egTestLeadWire.yaml';
import egTestPoint from './ESRIGas/egTestPoint.yaml';
import egTransmissionPipe from './ESRIGas/egTransmissionPipe.yaml';
import egUnknown from './ESRIGas/egUnknown.yaml';
import egWellheadSourceFlange from './ESRIGas/egWellheadSourceFlange.yaml';

import esCheckValve from './ESRISewer/esCheckValve.yaml';
import esCleanout from './ESRISewer/esCleanout.yaml';
import esForceMain from './ESRISewer/esForceMain.yaml';
import esGravityMain from './ESRISewer/esGravityMain.yaml';
import esGreaseTrap from './ESRISewer/esGreaseTrap.yaml';
import esInvertedSiphon from './ESRISewer/esInvertedSiphon.yaml';
import esLateral from './ESRISewer/esLateral.yaml';
import esManhole from './ESRISewer/esManhole.yaml';
import esOutlet from './ESRISewer/esOutlet.yaml';
import esReliefValve from './ESRISewer/esReliefValve.yaml';
import esServiceConnection from './ESRISewer/esServiceConnection.yaml';
import esStation from './ESRISewer/esStation.yaml';
import esSystemValve from './ESRISewer/esSystemValve.yaml';
import esTreatment from './ESRISewer/esTreatment.yaml';
import esUnknown from './ESRISewer/esUnknown.yaml';

import wwFlume from './SanitarySewer/wwFlume.yaml';
import wwLateralPipe from './SanitarySewer/wwLateralPipe.yaml';
import wwManhole from './SanitarySewer/wwManhole.yaml';
import wwOrifice from './SanitarySewer/wwOrifice.yaml';
import wwOutfall from './SanitarySewer/wwOutfall.yaml';
import wwOutlet from './SanitarySewer/wwOutlet.yaml';
import wwPipe from './SanitarySewer/wwPipe.yaml';
import wwPump from './SanitarySewer/wwPump.yaml';
import wwPumpStation from './SanitarySewer/wwPumpStation.yaml';
import wwRoddingEye from './SanitarySewer/wwRoddingEye.yaml';
import wwScreen from './SanitarySewer/wwScreen.yaml';
import wwSiphon from './SanitarySewer/wwSiphon.yaml';
import wwSluice from './SanitarySewer/wwSluice.yaml';
import wwStorage from './SanitarySewer/wwStorage.yaml';
import wwValve from './SanitarySewer/wwValve.yaml';
import wwVortex from './SanitarySewer/wwVortex.yaml';
import wwWeir from './SanitarySewer/wwWeir.yaml';

import swCatchBasin from './Stormwater/swCatchBasin.yaml';
import swCatchpit from './Stormwater/swCatchpit.yaml';
import swChannel from './Stormwater/swChannel.yaml';
import swCulvert from './Stormwater/swCulvert.yaml';
import swGully from './Stormwater/swGully.yaml';
import swInlet from './Stormwater/swInlet.yaml';
import swLateralPipe from './Stormwater/swLateralPipe.yaml';
import swLinearDrain from './Stormwater/swLinearDrain.yaml';
import swManhole from './Stormwater/swManhole.yaml';
import swOutfall from './Stormwater/swOutfall.yaml';
import swOutlet from './Stormwater/swOutlet.yaml';
import swPipe from './Stormwater/swPipe.yaml';
import swPump from './Stormwater/swPump.yaml';
import swPumpStation from './Stormwater/swPumpStation.yaml';
import swRoddingEye from './Stormwater/swRoddingEye.yaml';
import swScreen from './Stormwater/swScreen.yaml';
import swSluice from './Stormwater/swSluice.yaml';
import swStorage from './Stormwater/swStorage.yaml';
import swValve from './Stormwater/swValve.yaml';
import swVortex from './Stormwater/swVortex.yaml';
import swWeir from './Stormwater/swWeir.yaml';

import control_valve from './WaterDistribution/control_valve.yaml';
import customer from './WaterDistribution/customer.yaml';
import fitting from './WaterDistribution/fitting.yaml';
import fixed_head from './WaterDistribution/fixed_head.yaml';
import float_valve from './WaterDistribution/float_valve.yaml';
import general_asset from './WaterDistribution/general_asset.yaml';
import generator from './WaterDistribution/generator.yaml';
import hydrant from './WaterDistribution/hydrant.yaml';
import manhole from './WaterDistribution/manhole.yaml';
import meter from './WaterDistribution/meter.yaml';
import non_return_valve from './WaterDistribution/non_return_valve.yaml';
import other_valve from './WaterDistribution/other_valve.yaml';
import pipe from './WaterDistribution/pipe.yaml';
import pump from './WaterDistribution/pump.yaml';
import pump_station from './WaterDistribution/pump_station.yaml';
import service_valve from './WaterDistribution/service_valve.yaml';
import tank from './WaterDistribution/tank.yaml';
import well from './WaterDistribution/well.yaml';
import wtw from './WaterDistribution/wtw.yaml';

/* eslint-disable  @typescript-eslint/no-explicit-any */
const yamlMapping: { [key: string]: { [key: string]: any } } = {
	CombinedSewer: {
		cbFlume: cbFlume,
		cbLateralPipe: cbLateralPipe,
		cbManhole: cbManhole,
		cbOrifice: cbOrifice,
		cbOutfall: cbOutfall,
		cbOutlet: cbOutlet,
		cbPipe: cbPipe,
		cbPump: cbPump,
		cbPumpStation: cbPumpStation,
		cbRoddingEye: cbRoddingEye,
		cbScreen: cbScreen,
		cbSiphon: cbSiphon,
		cbSluice: cbSluice,
		cbStorage: cbStorage,
		cbValve: cbValve,
		cbVortex: cbVortex,
		cbWeir: cbWeir,
	},
	ESRIGas: {
		egACMitigationWire: egACMitigationWire,
		egAnode: egAnode,
		egBondingLine: egBondingLine,
		egCPCable: egCPCable,
		egCompressor: egCompressor,
		egControllableTee: egControllableTee,
		egControllableValve: egControllableValve,
		egCustomerPipe: egCustomerPipe,
		egDecoupler: egDecoupler,
		egDistributionPipe: egDistributionPipe,
		egExcessFlowValve: egExcessFlowValve,
		egFlowValve: egFlowValve,
		egGatheringPipe: egGatheringPipe,
		egGroundingPoint: egGroundingPoint,
		egLamp: egLamp,
		egLineStopper: egLineStopper,
		egLinearAnode: egLinearAnode,
		egMeter: egMeter,
		egPressureMonitoringDevice: egPressureMonitoringDevice,
		egPressureSensorPipe: egPressureSensorPipe,
		egPump: egPump,
		egRectifier: egRectifier,
		egRegulator: egRegulator,
		egReliefValve: egReliefValve,
		egRiserPipe: egRiserPipe,
		egScrubber: egScrubber,
		egServicePipe: egServicePipe,
		egServiceStation: egServiceStation,
		egStationPipe: egStationPipe,
		egStoragePipe: egStoragePipe,
		egStrainer: egStrainer,
		egTestLeadWire: egTestLeadWire,
		egTestPoint: egTestPoint,
		egTransmissionPipe: egTransmissionPipe,
		egUnknown: egUnknown,
		egWellheadSourceFlange: egWellheadSourceFlange,
	},
	ESRISewer: {
		esCheckValve: esCheckValve,
		esCleanout: esCleanout,
		esForceMain: esForceMain,
		esGravityMain: esGravityMain,
		esGreaseTrap: esGreaseTrap,
		esInvertedSiphon: esInvertedSiphon,
		esLateral: esLateral,
		esManhole: esManhole,
		esOutlet: esOutlet,
		esReliefValve: esReliefValve,
		esServiceConnection: esServiceConnection,
		esStation: esStation,
		esSystemValve: esSystemValve,
		esTreatment: esTreatment,
		esUnknown: esUnknown,
	},
	SanitarySewer: {
		wwFlume: wwFlume,
		wwLateralPipe: wwLateralPipe,
		wwManhole: wwManhole,
		wwOrifice: wwOrifice,
		wwOutfall: wwOutfall,
		wwOutlet: wwOutlet,
		wwPipe: wwPipe,
		wwPump: wwPump,
		wwPumpStation: wwPumpStation,
		wwRoddingEye: wwRoddingEye,
		wwScreen: wwScreen,
		wwSiphon: wwSiphon,
		wwSluice: wwSluice,
		wwStorage: wwStorage,
		wwValve: wwValve,
		wwVortex: wwVortex,
		wwWeir: wwWeir,
	},
	Stormwater: {
		swCatchBasin: swCatchBasin,
		swCatchpit: swCatchpit,
		swChannel: swChannel,
		swCulvert: swCulvert,
		swGully: swGully,
		swInlet: swInlet,
		swLateralPipe: swLateralPipe,
		swLinearDrain: swLinearDrain,
		swManhole: swManhole,
		swOutfall: swOutfall,
		swOutlet: swOutlet,
		swPipe: swPipe,
		swPump: swPump,
		swPumpStation: swPumpStation,
		swRoddingEye: swRoddingEye,
		swScreen: swScreen,
		swSluice: swSluice,
		swStorage: swStorage,
		swValve: swValve,
		swVortex: swVortex,
		swWeir: swWeir,
	},
	WaterDistribution: {
		control_valve: control_valve,
		customer: customer,
		fitting: fitting,
		fixed_head: fixed_head,
		float_valve: float_valve,
		general_asset: general_asset,
		generator: generator,
		hydrant: hydrant,
		manhole: manhole,
		meter: meter,
		non_return_valve: non_return_valve,
		other_valve: other_valve,
		pipe: pipe,
		pump: pump,
		pump_station: pump_station,
		service_valve: service_valve,
		tank: tank,
		well: well,
		wtw: wtw,
	},
};

export default yamlMapping;

// THIS FILE IS AUTO-GENERATED BY PREBUILD SCRIPT - DO NOT EDIT
